// extracted by mini-css-extract-plugin
export default {"container":"team-members_container__3JIyT","inner":"team-members_inner__3radL","item":"team-members_item__2j8cX","plus":"team-members_plus__1H4jd","dots":"team-members_dots__31hFG"};